import React from "react";
import { FileText } from "lucide-react";

/**
 * Component displayed when no records are found
 */
export const EmptyState: React.FC = () => {
  return (
    <tr>
      <td
        colSpan={13}
        className="px-4 py-12 text-sm bg-gradient-to-r from-gray-50/50 to-slate-50/30 text-center"
      >
        <div className="flex flex-col items-center gap-3">
          <div className="w-12 h-12 bg-gray-100 rounded-full flex items-center justify-center">
            <FileText />
          </div>
          <div>
            <p className="text-gray-600 font-medium">No records found</p>
            <p className="text-gray-500 text-xs mt-1">
              Try adjusting your filters or date range
            </p>
          </div>
        </div>
      </td>
    </tr>
  );
};
